module.exports = __webpack_public_path__ + "static/img/yellow-bg.02760036.jpg";